/**
 * Loading + not-found fallbacks for the workflow detail route — PURE (props
 * in, JSX out). Extracted from `$specId.tsx` to keep the route thin
 * (frontend-doctrine §4.6). The not-found copy deliberately does not
 * distinguish "doesn't exist" from "not yours": `specs.getById` returns null
 * for both so ownership never leaks existence.
 */

export function WorkflowDetailLoading() {
  return (
    <div className="mx-auto flex h-[calc(100vh-9rem)] max-w-6xl items-center justify-center 2xl:h-[calc(100vh-4rem)] 2xl:max-w-none">
      <p className="font-body text-[13px] text-home-ink/45 dark:text-white/45">
        Loading…
      </p>
    </div>
  );
}

export function WorkflowNotFound({ onBack }: { readonly onBack: () => void }) {
  return (
    <div className="mx-auto flex h-[calc(100vh-9rem)] max-w-md flex-col items-center justify-center gap-4 text-center">
      <h1 className="font-display text-xl font-semibold text-home-ink dark:text-white">
        Workflow not found
      </h1>
      <p className="font-body text-[13px] text-home-ink/55 dark:text-white/55">
        This workflow doesn't exist, or it isn't yours.
      </p>
      <button
        type="button"
        onClick={onBack}
        className="rounded-full bg-home-ink px-4 py-2 font-body text-[13px] font-semibold text-home-cream dark:bg-surface-dark-raised dark:text-white"
      >
        Back to workflows
      </button>
    </div>
  );
}
